import React, { useEffect, useState } from 'react';
import "/node_modules/bootstrap/dist/css/bootstrap.min.css";
import "/node_modules/bootstrap/dist/js/bootstrap.bundle.min.js";
import '../../../CSS/TablaHerramientas.css'
import { getPermission } from '../../../Conexiones/Conexion';
import { BsPlus } from 'react-icons/bs';
import { useNavigate } from "react-router";
import { Button, CloseButton, Modal } from 'react-bootstrap';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { deleteApi, getApi, postApi, putApi } from '../../../Conexiones/Models';
import { errorMessage, errorToast, successToast, warningModal, warningToast } from '../../../Utils/AlertMessage';
import Loading from '../../../Utils/Loading';

function TablaBodegas() {
    const navigate = useNavigate();
    const [bodegas,setBodegas]=useState([]);
    const [tablaBodegas,setTablaBodegas]=useState([]);
    const [busqueda,setBusqueda] = useState ('');
    const usuario = JSON.parse(sessionStorage.getItem('user'));
    const idUsuario = usuario[0].idUsuario;
    const uri = 'bodegas/';
    const [isLoading,setIsLoading]=useState(false);

    //AGREGAR
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [nombreAdd, setNombreAdd] = useState();
    const [direccionAdd,setDireccionAdd]=useState('')
    const [isSaving, setSaving] = useState(false);
    const handleCloseAdd = () =>{
        handleClose();
        setNombreAdd('');
        setDireccionAdd('');
    }
    //EDITAR
    const [showEdit, setShowEdit] = useState(false);
    const handleCloseEdit = () => setShowEdit(false);
    const [editNombre,setEditNombre] = useState ()
    const [editDirec,setEditDirec] = useState ()
    const [idBodega,setBodega] = useState ()
    const handleShowEdit = (id,nombre,direccion) =>{
        setShowEdit(true);
        setEditNombre(nombre);
        setEditDirec(direccion);
        setBodega(id);
    }

    useEffect (()=>{
        const getBodegas = async () =>{
            setIsLoading(true);
            const permiso = await getPermission(idUsuario,7);
            if(permiso){
                const endpoint = uri;
                const res = await getApi(endpoint);
                if(res.status === 1){
                    if(res.data.length !== undefined){
                        setBodegas(res.data)
                        setTablaBodegas(res.data)
                    }else{
                        errorMessage(res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }else{
                navigate('/inicio')
            }
            setIsLoading(false);
        }
        getBodegas()
    },[idUsuario,navigate])

    const getBodegas = async () =>{
        const endpoint = uri;
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setBodegas(res.data);
                setTablaBodegas(res.data);
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    }
    
    const buscar = e => {
        setBusqueda(e.target.value);
        filtrar(e.target.value);
    }

    const filtrar= (textoIngresado) =>{
        var resultadoBusqueda = tablaBodegas.filter((elemento)=> {
            if (elemento.nombreBod.toString().toLowerCase().includes(textoIngresado.toLowerCase())){
                return elemento; 
            }
            return resultadoBusqueda;
        });
        setBodegas(resultadoBusqueda);
    }

    const regresar = () => {
        navigate('/inicio/Catalogos');
    }
    
    //ELIMINAR
    const modalEliminar = (id) => { 
        warningModal('¿QUIERES ELIMINAR ESTA BODEGA?')
        .then(async (result)  => {
            if (result.isConfirmed) {
                const endpoint = uri + id;
                const res = await deleteApi(endpoint);
                if(res.status === 1){
                    if(res.data.message==="registro eliminado"){
                        getBodegas();
                        successToast("ELIMINADO");
                    }else{
                        errorToast("¡ERROR!",res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }
        })
    }
    //AGREGAR
    const agregarBodega = async (e) =>{
        setSaving(true)
        e.preventDefault()
        if(nombreAdd.trim().length === 0 | direccionAdd.trim().length === 0){
            warningToast('CAMPOS VACIOS','EL CAMPO NOMBRE O DIRECCION ESTA VACÍO');
        }else{
            const endpoint = uri;
            const data = {nombre:nombreAdd,direccion:direccionAdd};
            const res = await postApi(endpoint,data);
            if(res.status === 1){
                if(res.data.message==="¡Registro creado correctamente!"){
                    handleCloseAdd();
                    getBodegas();
                    successToast("AGREGADO");
                }else{
                    errorToast("¡ERROR!",res.data.message);
                }
            }else if(res.status === 210){
                navigate('/');
            }else{
                errorMessage(res.message);
            }
        }
        setSaving(false)
    }
    //EDITAR
    const update= async (e) => {
        setSaving(true)
        e.preventDefault()
        if(editNombre.trim().length === 0 | editDirec.trim().length === 0){
            warningToast('CAMPOS VACIOS','EL CAMPO NOMBRE O DIRECCION ESTA VACÍO');
        }else{
            const endpoint = uri + idBodega;
            const data = {nombre:editNombre,direccion:editDirec};
            const res = await putApi(endpoint,data);
            if(res.status === 1){
                if(res.data.message==="Registro modificado"){
                    handleCloseEdit();
                    getBodegas();
                    successToast("EDITADO");
                }else{
                    errorToast("¡ERROR!",res.data.message);
                }
            }else if(res.status === 210){
                navigate('/');
            }else{
                errorMessage(res.message);
            }
        }
        setSaving(false)
    }

    return (
        <div className="tablaHerramientas">
            {
                isLoading ? 
                <Loading />:
                <div>
                    <div className='contabilidades-header'>
                        <div className='fab'><FaArrowLeftLong className='arrow' onClick={regresar} title='REGRESAR'/></div>
                        <label className="text-uppercase">gestión de bodegas</label>
                    </div>
                    <div className='divboton' >                                                                                             
                        <div className='boton' style={{display:'flex', justifyContent:'space-between'}}>
                            <button  className="btn btn-light btncolor" onClick={handleShow} type="button">
                                <label className="agregar">BODEGA</label><BsPlus style={{fontSize:'25px'}}/>
                            </button>
                            <input value={busqueda} onChange={buscar} type="search" placeholder="Buscar"  className="form-control" style={{width:'50%'}} aria-describedby="basic-addon1"/> 
                        </div>
                    </div>
                    {
                        bodegas.length === 0 ? (<h3 style={{marginTop:'30vh'}}>AUN NO HAY REGISTROS</h3>):(
                            <div className="tabla-cajaA">
                                <div className="table tabla">
                                    <table className="table table-hover table-bordered text-uppercase">
                                        <thead className="encabezado">
                                            <tr>
                                                <th > BODEGA </th>
                                                <th>DIRECCIÓN</th>
                                                <th style={{width:'50%'}}>ACCIONES</th>
                                            </tr>
                                        </thead>
                                        <tbody >
                                        { bodegas.map( bodega => {
                                            return (
                                                <tr key={bodega.idBodega}>
                                                    <td valign="middle"  data-bs-toggle="modal" data-bs-target={`#id${'b'+bodega.idBodega}`} >{bodega.nombreBod}</td>
                                                    <td valign="middle">{bodega.direccionBod}</td>
                                                    <td>
                                                        <div>
                                                            <div className="btn iconoH"  onClick={() => handleShowEdit(bodega.idBodega,bodega.nombreBod,bodega.direccionBod)} style={{margin:'5px'}}>
                                                                <span className="bi bi-pen" title="EDITAR"></span>
                                                            </div>
                                                            <div className="btn iconoH" style={{margin:'5px'}} onClick={() => modalEliminar(bodega.idBodega)}>
                                                                <span className="bi bi-trash" title="ELIMINAR"></span>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )
                    }

                    {/*AGREGAR BODEGA*/}
                    <Modal show={show} onHide={handleClose} id="modal-agregar-bodega">
                        <Modal.Header className=' btncolor'>
                            <Modal.Title>AGREGAR BODEGA</Modal.Title>
                            <CloseButton  style={{backgroundColor:"white"}} onClick={handleCloseAdd} />
                        </Modal.Header>
                        <form onSubmit={agregarBodega}>
                            <div className="divO">
                                <label className="obligatorio">Obligatorio *</label>  
                            </div>
                            <Modal.Body  style={{textAlign:'left', marginTop:'-20px'}}>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">NOMBRE <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <input type="text" className="form-control"  id="exampleFormControlInput1" required 
                                    onChange={e => setNombreAdd(e.target.value) } />
                                </div>  
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput1" className="text-uppercase">direccion
                                        <label title="OBLIGATORIO" className="obligatorio">*</label>
                                    </label>
                                    <input type="text" className="form-control" required value={direccionAdd} onChange={(e)=>setDireccionAdd(e.target.value)} aria-describedby="basic-addon1"/>   
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button type="button" className="btn btn-secondary" onClick={handleCloseAdd}>CANCELAR</Button>                                               
                                {isSaving===true?
                                    <Button className="btn btn-primary" type="button" disabled >
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Loading...
                                    </Button>:
                                    <Button type="submit" className="btn btn-light btncolor" >GUARDAR CAMBIOS</Button>                                                
                                }
                            </Modal.Footer>
                        </form>
                    </Modal>  

                    {/*EDITAR BODEGA*/}
                    <Modal  show={showEdit} onHide={handleCloseEdit} id="modal-editar-bodega">
                        <Modal.Header className=' btncolor'>
                            <Modal.Title>EDITAR BODEGA</Modal.Title>
                            <CloseButton  style={{backgroundColor:"white"}} />
                        </Modal.Header>
                        <form onSubmit={update}>
                            <div className="divO">
                                <label className="obligatorio">Obligatorio *</label>  
                            </div>
                            <Modal.Body  style={{textAlign:'left', marginTop:'-20px'}}>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">NOMBRE <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <input type="text" className="form-control"  id="exampleFormControlInput1" required 
                                    onChange={e => setEditNombre(e.target.value)} defaultValue={editNombre}/>
                                </div>  
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">DIRECCION <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <input type="text" className="form-control"  id="exampleFormControlInput1" required 
                                    onChange={e => setEditDirec(e.target.value)} defaultValue={editDirec}/>
                                </div> 
                            </Modal.Body>
                            <Modal.Footer>
                                <Button type="button" className="btn btn-secondary" onClick={handleCloseEdit}>CANCELAR</Button>                                               
                                    {isSaving===true? 
                                        <Button className="btn btn-primary" type="button" disabled >
                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                            Loading...
                                        </Button>:
                                        <Button type="submit" className="btn btn-light btncolor" >GUARDAR CAMBIOS</Button>                                                
                                    }
                            </Modal.Footer>
                        </form>
                    </Modal>
                </div>
            }
        </div>
    );
}

export default TablaBodegas;